import Vue from 'vue';
import VueRouter from 'vue-router';
// import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "business" */ '../views/Landing.vue'),
  },
  {
    path: '/landing',
    name: 'Landing',
    component: () => import(/* webpackChunkName: "business" */ '../views/Landing.vue'),
  },
  {
    path: '/business/:id/edit',
    name: 'BusinessEdit',
    // route level code-splitting
    // this generates a separate chunk (business.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "business" */ '../views/BusinessEdit.vue'),
  },
  {
    path: '/business/:id',
    name: 'Business',
    component: () => import(/* webpackChunkName: "business" */ '../views/Business.vue'),
  },
  {
    path: '/businesses',
    name: 'Businesses',
    component: () => import(/* webpackChunkName: "business" */ '../views/Businesses.vue'),
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import(/* webpackChunkName: "contact" */ '../views/Contact.vue'),
  },
  {
    path: '/invoice/:id',
    name: 'Invoice',
    component: () => import(/* webpackChunkName: "invoice" */ '../views/Invoice.vue'),
  },
  {
    path: '/invoices',
    name: 'Invoices',
    component: () => import(/* webpackChunkName: "invoice" */ '../views/Invoices.vue'),
  },
  {
    path: '/license/:id',
    name: 'License',
    component: () => import(/* webpackChunkName: "license" */ '../views/License.vue'),
  },
  {
    path: '/licenses',
    name: 'Licenses',
    component: () => import(/* webpackChunkName: "license" */ '../views/Licenses.vue'),
  },
  {
    path: '/membership-card/:id',
    name: 'MembershipCard',
    component: () => import(/* webpackChunkName: "membership-card" */ '../views/MembershipCard.vue'),
  },
  {
    path: '/listing/:id',
    name: 'Listing',
    component: () => import(/* webpackChunkName: "listing" */ '../views/Listing.vue'),
  },
  {
    path: '/listing/:id/stats',
    name: 'ListingStats',
    component: () => import(/* webpackChunkName: "listing" */ '../views/ListingStats.vue'),
  },
  {
    path: '/listings',
    name: 'Listings',
    component: () => import(/* webpackChunkName: "listing" */ '../views/Listings.vue'),
  },
  {
    path: '/enhance/:id',
    name: 'Enhance',
    component: () => import(/* webpackChunkName: "enhance" */ '../views/ListingEnhance.vue'),
  },
  {
    path: '/upgrade/:id',
    name: 'Upgrade',
    component: () => import(/* webpackChunkName: "enhance" */ '../views/ListingUpgrade.vue'),
  },
  {
    path: '/membership/:id',
    name: 'Membership',
    component: () => import(/* webpackChunkName: "membership" */ '../views/Membership.vue'),
  },
  {
    path: '/memberships',
    name: 'Memberships',
    component: () => import(/* webpackChunkName: "membership" */ '../views/Memberships.vue'),
  },
  {
    path: '/payment-methods',
    name: 'PaymentMethods',
    component: () => import(/* webpackChunkName: "paymentmethods" */ '../views/PaymentMethods.vue'),
  },
  {
    path: '/tools/document-library',
    name: 'DocumentLibrary',
    component: () => import(/* webpackChunkName: "tools" */ '../views/DocumentLibrary.vue'),
  },
  {
    path: '/tools/current-legislation',
    name: 'CurrentLegislation',
    component: () => import(/* webpackChunkName: "tools" */ '../views/CurrentLegislation.vue'),
  },
  {
    path: '/tools/trends-insights-report',
    name: 'TrendsInsights',
    component: () => import(/* webpackChunkName: "tools" */ '../views/TrendsInsights.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
